<script setup lang="ts">
import BaseWidget from '../dashboard/BaseWidget.vue';

// PROPS
const props = defineProps<{
  title: string;
  number: string;
  footer?: string;
}>();

// FUNCTIONS
const setTextColor = (type: any) => {
  const value = parseFloat(type);
  if (value < 0) {
    return 'red';
  } else {
    return 'green';
  }
};
</script>
<template>
  <div class="number-widget">
    <base-widget>
      <template v-slot:title>
        <div>{{ props.title }}</div>
      </template>
      <template v-slot:body>
        <div>{{ props.number }}</div>
      </template>
      <template v-slot:footer>
        <div :class="setTextColor(props.footer)">{{ props.footer }}</div>
      </template>
    </base-widget>
  </div>
</template>
<style lang="scss">
.number-widget {
  .body {
    font-size: $h1;
  }

  .footer {
    .green {
      color: $color-green-50;
    }
    .red {
      color: $color-red-50;
    }
  }
}
</style>
